import { ElementsArray } from 'polotno/model/group-model';
import { StoreType } from 'polotno/model/store';

export function sendElementsBackward(store: StoreType, elements: ElementsArray) {
    store.activePage.moveElementsDown(elements.map(element => element.id));
}
